import ChangeDefaultPassword from './ChangeDefaultPassword';

export default ChangeDefaultPassword;
